import { Image, Label, Panel } from "@mcleod/components";
import { MetadataField, VerticalAlignment } from "@mcleod/core";
import { UIDesigner } from "./UIDesigner";

export class DesignerTool extends Panel {
  image: Image;
  toolName: string;

  constructor(designer: UIDesigner, name: string, field?: MetadataField | any) {
    super({ fillRow: true, draggable: true, allowSelect: false, wrap: false, color: "subtle.darker", verticalAlign: VerticalAlignment.CENTER });
    let toolProps;
    if (field == null)
      toolProps = {name: name};
    else if (field instanceof MetadataField)
      toolProps = designer.getToolPropsForField(field);
    else
      toolProps = field;
    name = toolProps?.toolType || name;
    const proper = name;
    name = name.replace(" ", "");
    this.toolName = name;
    this.image = new Image({ name: "designer/" + name.toLowerCase(), height: 20, width: 20, rowBreak: false });
    this.add(this.image);
    this.add(new Label({ caption: toolProps.name || proper, fontSize: "small" }));
    this.addDragStartListener(event => designer.dragTool(event, this, toolProps));
    this.addClickListener(event => designer.selectTool(this));
    this.addDblClickListener(event => designer.toolDblClicked(this, toolProps));
  }
}
